module.exports = __webpack_public_path__ + "img/classes2.ada0863d.png";